var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.13437 1 1 4.13437 1 8C1 11.8656 4.13437 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13437 11.8656 1 8 1ZM8 13.8125C4.79063 13.8125 2.1875 11.2094 2.1875 8C2.1875 4.79063 4.79063 2.1875 8 2.1875C11.2094 2.1875 13.8125 4.79063 13.8125 8C13.8125 11.2094 11.2094 13.8125 8 13.8125Z",
    fill: "#FF9000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24976 5.25C7.24976 5.44891 7.32877 5.63968 7.46943 5.78033C7.61008 5.92098 7.80084 6 7.99976 6C8.19867 6 8.38943 5.92098 8.53009 5.78033C8.67074 5.63968 8.74976 5.44891 8.74976 5.25C8.74976 5.05109 8.67074 4.86032 8.53009 4.71967C8.38943 4.57902 8.19867 4.5 7.99976 4.5C7.80084 4.5 7.61008 4.57902 7.46943 4.71967C7.32877 4.86032 7.24976 5.05109 7.24976 5.25ZM8.37476 7H7.62476C7.55601 7 7.49976 7.05625 7.49976 7.125V11.375C7.49976 11.4438 7.55601 11.5 7.62476 11.5H8.37476C8.44351 11.5 8.49976 11.4438 8.49976 11.375V7.125C8.49976 7.05625 8.44351 7 8.37476 7Z",
    fill: "#FF9000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeInfoIcon);
export default __webpack_public_path__ + "orange-info-icon.99adad91b44f43490ceaa4502642c905.svg";
export { ForwardRef as ReactComponent };